import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col, Row, Card, CardBody, Button } from 'reactstrap';
import { Field, reduxForm, FieldArray } from 'redux-form'
import DropDownSelect from '../Dropdown/index';
import DatePickerField from '../Datepicker/index';
import { HORIZONTAL } from '../constants';
import { setAggregateData } from './helper';
import AggregatePredefined from './AggregatePredefined/index';
import moment from 'moment';
// import { checkSubmitError, checkZeroValue, checkOne } from '../helper';

const renderMembers = ({ fields, data, aggregateFiledTypeDropdown, creditDropdown, aggregateFieldDirectionDropdown,refreshKeyFields, meta: { error, submitFailed } }) => (
    < ul >
        {
            fields.map((member, index) => (
                < li key={index} >
                    <Row className="d-flex mb-3">
                        <Col sm="5" className="px-2">
                            {/* <div className="d-flex align-items-center text-secondary border radius-5 p-2"> */}
                            <Field
                                component="input"
                                name={`${member}.fieldName`}
                                type="text"
                                placeholder="Field Name"
                                className="p-2 w-100 radius-5 border risk-grade-input"
                                onBlur={()=>refreshKeyFields(null)} />
                            {/* </div> */}
                        </Col>
                        <Col sm="4" className="px-2">
                            <div className="border dropdown-counterparty riskgrade-category-dd">
                                <Field
                                    name={`${member}.creditDropdown`}
                                    type="text"
                                    component={DropDownSelect}
                                    label="State"
                                    data={creditDropdown}
                                />
                            </div>
                        </Col>
                        <Col sm="3" className="px-2">
                            <div className="border dropdown-counterparty riskgrade-category-dd">
                                <Field
                                    name={`${member}.fieldType`}
                                    type="text"
                                    component={DropDownSelect}
                                    label="State"
                                    data={aggregateFiledTypeDropdown}
                                />
                            </div>
                        </Col>
                        <Col sm="4" className="px-2">
                            <div className="border dropdown-counterparty riskgrade-category-dd">
                                <Field
                                    name={`${member}.fieldDirection`}
                                    type="text"
                                    component={DropDownSelect}
                                    label="State"
                                    data={aggregateFieldDirectionDropdown}
                                />
                            </div>
                        </Col>
                        {(data) ? (data.values.aggregateFields[member.match(/\[(.*?)\]/)[1]].fieldDirection === HORIZONTAL) ?
                            
                            <Col sm="6" className="px-2">
                                <Row>
                                    <Col xs='12'>
                                        <Field
                                            component={DatePickerField}
                                            name={`${member}.fromDate`}
                                            placeholder="From"
                                            className="p-2 w-100 radius-5 border risk-grade-input" />
                                    </Col>
                                    <Col xs='12'>
                                        <Field
                                            component={DatePickerField}
                                            name={`${member}.toDate`}
                                            placeholder="To"
                                            className="p-2 w-100 radius-5 border risk-grade-input" />
                                    </Col>
                                </Row>
                            </Col> : <Col sm="6" className="px-2">
                                {/* <div className="d-flex align-items-center text-secondary border radius-5 p-2"> */}
                                <Field
                                    component="input"
                                    name={`${member}.fieldValue`}
                                    type="text"
                                    disabled
                                    placeholder="Field Value"
                                    className="p-2 w-100 radius-5 border risk-grade-input" />
                                {/* </div> */}
                            </Col> : ''}
                        <Col sm="2" className="px-2 text-right"><a onClick={() => {fields.remove(index);refreshKeyFields(data.values.aggregateFields[member.match(/\[(.*?)\]/)[1]]);}}><i className="icon-close text-danger pointer"></i></a> </Col>
                    </Row>
                </li>
            ))
        }
        < Row >
            <Button type="button" className="d-flex ml-auto text-primary text-decoration-none pr-0" color="link" onClick={() => fields.push({})}><i className="icon-plus mr-2 text-decoration-none"></i>Add More</Button>
        </Row >

    </ul >
)



class AggregateFieldsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidMount() {
        this.props.initialize({
            'aggregateFields': [{
                fieldName: '',
                creditDropdown: '',
                fieldType: '',
                fieldDirection: '',
                fieldValue: '',
                fromDate: moment(null),
                toDate: moment(null)
            }]
        })
    }
    componentDidUpdate(prevProps) {
        if (this.props.aggregateFieldInitialData !== prevProps.aggregateFieldInitialData) {
            let tempAggregateFieldData = setAggregateData(this.props.aggregateFieldInitialData);
            this.props.initialize({
                aggregateFields: tempAggregateFieldData
            })
        }
    }
    render() {
        const { error } = this.props
        return (
            <form>
                <Card className="shadow-none">
                    <CardBody>
                        <Row className="mb-1 px-2">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }} className="mb-1">Predefined Fields</span>
                        </Row>
                        <Row className="mb-1">
                            <AggregatePredefined predefinedData={this.props.aggregatePredefinedData} />
                        </Row>
                        <Row className="mb-1 px-2">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }} className="mb-1">Fields</span>
                        </Row>
                        <Row className="header-blue mb-3">
                            <Col sm="5" className="px-2">Field Name</Col>
                            <Col sm="4" className="px-2">Credit Worthiness</Col>
                            <Col sm="3" className="px-2">Field Type</Col>
                            <Col sm="4" className="px-2">Direction</Col>
                            <Col sm="6" className="px-2">Value</Col>
                            <Col sm="" className="px-2"></Col>
                        </Row>
                        <fieldset disabled={!this.props.aggregateFieldDisable}>
                            <FieldArray name="aggregateFields"
                                component={renderMembers}
                                data={this.props.aggregateFormData}
                                aggregateFiledTypeDropdown={this.props.aggregateFieldType}
                                creditDropdown={this.props.creditWorthinessDropdownoptions}
                                aggregateFieldDirectionDropdown={this.props.aggregateFieldDirection}
                                refreshKeyFields={this.props.refreshKeyFields} />
                            {/* <FieldArray name="members" fields={this.state.riskGradeBody} component={renderMembers} riskLevels={this.props.riskLevels}/> */}
                        </fieldset>
                    </CardBody>

                </Card>

                <strong className='text-danger mb-5'>{error ? error : ""}</strong>
            </form>
        )
    }
}


const mapStateToProps = (state, ownProps) => ({
    // editdata: state.corporateOnBoardingCreate.editData
    aggregateFormData: state.form.AggregateFieldsForm

})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

export default reduxForm({
    form: 'AggregateFieldsForm'
})(connect(mapStateToProps, mapDispatchToProps)(AggregateFieldsForm))
